import { getConfig } from './get-config';

export const waitUntilGrecaptchaReady = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      resolve();
      return;
    }

    const interval = setInterval(() => {
      if (window.grecaptcha && (window as any).grecaptcha.execute) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
    setTimeout(() => {
      clearInterval(interval);
      reject(new Error('grecaptcha não ficou pronto a tempo.'));
    }, 5000);
  });
};

export async function gerarTokenRecaptcha(action: string): Promise<string> {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return Promise.resolve('localhost-fake-recaptcha-token');
  }

  return new Promise((resolve, reject) => {
    if (!window.grecaptcha || !window.grecaptcha.execute) {
      return reject(
        new Error('reCAPTCHA não carregado ou método indisponível'),
      );
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(getConfig('REACT_APP_KEY_CAPTCHA'), { action })
        .then((token: string) => resolve(token))
        .catch(reject);
    });
  });
}
